import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { getFormattedErr } from 'src/helpers';
import apiClient from 'src/helpers/apiClient';

export const getCurrencySymbols = createAsyncThunk(
  'get/currency-symbols',
  async (_, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getGeneralApi()
      ).generalApiGetCurrencySymbols();
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);

export const getConstants = createAsyncThunk(
  'get/constants/values',
  async (_, { rejectWithValue }) => {
    try {
      const response = await (
        await apiClient.getGeneralApi()
      ).generalApiGetConstantValues();
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error));
      return rejectWithValue(err.response.data);
    }
  },
);
